import React from "react";
import Spinner from "./Spinner";
import BeautifulSpinner from "./BeautifulSpinner";
import injectSheet from "react-jss";
import classNames from "classnames";

const AbsoluteLoaderContainer = (props) => {
  const {
    spinnerType,
    classes,
    spinnerWidth,
    title,
    totalCenter,
    backgroundColor,
    contained = false,
    className,
  } = props;
  const style1 = {
    backgroundColor: backgroundColor ? "rgb(243,245,247,.6)" : null,
    top: window.pageYOffset + "px",
  };

  return (
    <div
      className={classNames(
        contained && classes.containedContainer,
        !totalCenter && classes.absoluteContainer,
        className && className
      )}
      style={style1}
    >
      <div className={classes.absoluteContainerContent}>
        {!spinnerType || spinnerType === 0 ? (
          <BeautifulSpinner
            width={!spinnerWidth ? 100 : spinnerWidth}
            backColor={"red"}
          />
        ) : (
          <Spinner width={!spinnerWidth ? 100 : spinnerWidth} />
        )}
        <p style={{ fontSize: "16px" }}>{title}</p>
      </div>
    </div>
  );
};

const styles = {
  /*  "@global": {
    body: { overflow: "hidden" },
  }, */
  absoluteContainer: {
    position: "absolute",
    //left: "calc((100% / 20) + 64px)",
    width: "1088px",
    height: "100%",
    zIndex: 6,
    overflowX: "hidden",
  },
  containedContainer: {
    position: "unset",
    width: "100%",
    "& $absoluteContainerContent": {
      position: "unset",
      margin: "0 auto",
    },
  },
  absoluteContainerContent: {
    zIndex: 7,
    opacity: 1,
    position: "absolute",
    width: "300px",
    height: "150px",
    left: (props) =>
      props.stepsView ? "calc(65% - 150px)" : "calc(50% - 150px)",
    top: "calc(50% - 75px)",
    textAlign: "center",
  },
  "@media (max-width: 1168px)": {
    absoluteContainer: {
      left: "64px",
      width: "calc(100% - 64px)",
    },
    containedContainer: {
      width: "100%",
    },
  },
  "@media (max-width: 1023px)": {
    absoluteContainer: {
      left: 0,
      width: "100%",
      margin: 0,
      maxWidth: "100%",
      minWidth: "100%",
      padding: "0",
    },
    absoluteContainerContent: {
      left: "calc(50% - 150px)!important",
    },
  },
};
export default injectSheet(styles)(AbsoluteLoaderContainer);
